module.exports = __webpack_public_path__ + "img/竞赛-1.cdeeaff1.png";